export enum SanctionAppealCourtOutcome {
	Rejected = 1,
	PartiallyGranted = 2,
	Granted = 3,
}
